import script from "./Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Modal.vue?vue&type=script&setup=true&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=7628b29f&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7628b29f"]])

export default __exports__